// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3yJ4r","col":"styles_col__p87qh","fulfillmentStatus":"styles_fulfillmentStatus__3y_9N","emailCol":"styles_emailCol__3mQiM"};